<script>
  export let onClick

  export let size = "1.5rem"
</script>

<button on:click={onClick}>
  <img src="/assets/icons/icon_setting_active.png" alt="settings icon" style="width: {size}; height: {size}"/>
</button>

<style>
  button {
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }
</style>
